import { render, staticRenderFns } from "./addEquipFee.vue?vue&type=template&id=bd257fea&scoped=true"
import script from "./addEquipFee.vue?vue&type=script&lang=js"
export * from "./addEquipFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd257fea",
  null
  
)

export default component.exports